// src/components/admin/TorreDeControl/modals/WhatsAppModal.jsx
import React from 'react';
import { X, MessageSquare } from 'lucide-react';
import ChatView from './ChatView';

function WhatsAppModal({ item, itemType, onClose, userId = 2 }) {
  const phoneNumber = itemType === 'delivery' 
    ? item.recipient_phone 
    : item.telefono;

  const customerName = itemType === 'delivery'
    ? item.recipient_name
    : item.customer_name;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[10000] p-2 sm:p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl h-[calc(100dvh-1rem)] sm:h-[80dvh] min-h-0 overflow-hidden flex flex-col">
        {/* Header */}
        <div className="bg-[#B1336E] px-3 py-3 sm:px-6 sm:py-4 flex items-center justify-between gap-2 flex-shrink-0">
          <div className="flex min-w-0 items-center gap-3">
            <MessageSquare className="w-5 h-5 text-white" />
            <div className="min-w-0">
              <h3 className="text-white font-bold text-lg font-montserrat">
                Chat WhatsApp
              </h3>
              <p className="text-white/80 text-sm font-montserrat truncate">
                {customerName} - {phoneNumber}
              </p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="shrink-0 text-white hover:bg-white/20 p-2 rounded-lg transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Chat Content */}
        <div className="min-h-0 flex-1 overflow-hidden">
          {item.chat_id ? (
            <ChatView
              chatId={item.chat_id}
              onBackClick={onClose}
              userId={userId}
            />
          ) : (
            <div className="flex flex-col items-center justify-center h-full p-8 bg-slate-50">
              <MessageSquare className="w-16 h-16 text-slate-300 mb-4" />
              <p className="text-slate-600 text-center font-montserrat">
                No hay un chat activo con este número
              </p>
              <p className="text-slate-500 text-sm text-center mt-2 font-montserrat">
                {phoneNumber}
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default WhatsAppModal;
